import { useEffect } from 'react';

const useEscapeKey = (isOpen, onEscape, deps = []) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onEscape();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, onEscape, ...deps]);
};

export default useEscapeKey;
